<template>
    <el-dialog
        :visible.sync="visible"
        :append-to-body="true"
        style="text-align: center;"
        :before-close="onClose"
    >
        <el-image :src="url" />
    </el-dialog>
</template>

<script>

export default {
    name: 'PreviewImg',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },

    computed: {
    },

    created() {
    },

    methods: {
        onClose() {
            this.$emit('close')
        }
    }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
/deep/ .el-dialog {
    width: 80%;
}
</style>
